<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

interface Props {
  class?: HTMLAttributes['class']
  /** Maximum height before scrolling */
  maxHeight?: string
}

const props = withDefaults(defineProps<Props>(), {
  maxHeight: '50vh'
})
</script>

<template>
  <div
    :class="cn(
      'p-4 space-y-4 overflow-y-auto',
      props.class
    )"
    :style="{ maxHeight: maxHeight }"
  >
    <slot />
  </div>
</template>
